var map = {
	"./1.jpg": 72174,
	"./2.jpg": 52441,
	"./3.jpg": 65564,
	"./4.jpg": 83463,
	"./5.jpg": 15722,
	"./6.jpg": 7797,
	"./7.jpg": 3480,
	"./8.jpg": 61091,
	"./9.jpg": 70982
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 95898;